import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_445: DocMigration = {
  maxSchemaVersion: "0.0.445",
  description: "Remove panX and panY from viewports",
  apply(json: any) {
    for (const viewportKey in json.viewports) {
      const viewport = json.viewports[viewportKey];

      const oldPanX: number | undefined = viewport.panX;
      const oldPanY: number | undefined = viewport.panY;

      delete viewport.panX;
      delete viewport.panY;

      // this migration only applies to absolute viewports with explicit scaling
      if (viewport.scalingMethod !== "EXPLICIT" || viewport.positioningMethod !== "ABSOLUTE") {
        continue;
      }

      // if the scale is undefined, then the pan values are irrelevant
      if (viewport.scale === undefined) {
        continue;
      }

      let scale: number | undefined;

      // as of 2025-05-28 there are no viewports with parameterized scaling in customer docs
      // however, we can still do this simple check and use the parameter default value just in case
      if (isParameterRef(viewport.scale)) {
        const parameterId = viewport.scale.id;
        // there are no drawing scale system parameters
        const parameter = json.localParameters[parameterId] ?? json.globalParameters[parameterId];
        if (parameter && parameter.type === "DRAWING_SCALE") {
          if (parameter.defaultValue !== undefined) {
            scale = parameter.defaultValue;
          }
        }
      } else {
        scale = viewport.scale;
      }

      // scale may still be undefined at this point
      if (scale === undefined) {
        continue;
      }

      let newPanX: number | undefined;
      let newPanY: number | undefined;

      if (oldPanX !== undefined) {
        newPanX = oldPanX * scale;
        viewport.worldOriginInPageSpaceX = viewport.worldOriginInPageSpaceX + newPanX;
      }

      if (oldPanY !== undefined) {
        newPanY = oldPanY * scale;
        viewport.worldOriginInPageSpaceY = viewport.worldOriginInPageSpaceY + newPanY;
      }
    }
    return json;
  },
};

interface ParameterRef {
  readonly type: "PARAMETER_REF";
  readonly id: string;
}

function isParameterRef(v: any): v is ParameterRef {
  return (v as ParameterRef)?.type === "PARAMETER_REF";
}

export default migration_0_0_445;
